<template>
  <div>
    <home-banner />
    <div class="iot-bg">
      <recommend />
      <!--    <scenes/>-->
      <product />
    </div>
    <shop />
    <result />
    <policy />
    <consult />
    <home-footer />
  </div>
</template>

<script>
import HomeBanner from "./HomeBanner.vue";
import recommend from "./recommend.vue";
import scenes from "./scenes.vue";
import product from "./product.vue";
import shop from "./shop.vue";
import result from "./result.vue";
import policy from "./policy.vue";
import consult from "./consult.vue";
import homeFooter from "./footer.vue";
export default {
  components: {
    HomeBanner,
    recommend,
    scenes,
    product,
    shop,
    result,
    policy,
    consult,
    homeFooter,
  },
};
</script>

<style>
.iot-bg {
  background-image: url(../../assets/img/2.0/sbbg.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center top 124px;
}
</style>
